import './meetingform.less';

import * as _ from 'lodash';

/**
 * @typedef { import('./MeetingFormModel').MeetingFormModel } MeetingFormModel
 */

class MeetingFormController {
    
    static $inject = ['tromanGlobals'];

    constructor(tromanGlobals) {
        /** @type {boolean} */
        this.isPolitikerEnabled = tromanGlobals.systemInfo.IsPolitikerEnabled;
        /** @type {MeetingFormModel} */
        this.model = null;
    }

    organizationChanged() {
        if (this.meeting && !this.meeting.Id) {
            this.meeting.EnableTimereport = !!this.meeting.Organization?.EnableTimereport;

            if (this.meeting.Organization?.WageCalculationId) {
                this.meeting.WageCalculation = _.find(this.wageCalculations, x => x.Id === this.meeting.Organization.WageCalculationId);
            } else {
                this.meeting.WageCalculation = null;
            }
        }
    }
}

angular.module("tromanWeb").component("ergoMeetingForm", {
    template: require('./meetingform.html'),
    bindings: {
        meeting: '<',
        organizations: '<',
        wageCalculations: '<',
    },
    controller: MeetingFormController
});
